import React, { useEffect, useState } from 'react';
import * as NUMBER from '../../../../common/constants/number';
import * as TRANSLATE from '../../../../common/constants/live/translate';

export default function TranslateSelector (props) {
  const labelId = 'translate-language-list-label';
  const listBoxId = 'translate-language-listbox';

  // 버튼클릭시 포커스 이동
  useEffect(() => {
    setTimeout(() => {
      let selectorElem = document.getElementById(listBoxId);
      selectorElem.focus();
    }, NUMBER.DELAY_MOVE_FOCUS);
  }, []);

  const handleClick = (lang) => {
    props.onClick(lang);
  };

  const handleKeyDownEvent = (event) => {
    if (event.shiftKey && event.key === 'Tab' && event.target.id === listBoxId) {
      props.onBackFocus();
      event.preventDefault();
    }
  };

  return (
    <div className='module_translate_select_w'>
      <div className='translate_select_inner'>
        <span className='translate_select_text' id={labelId} role='label'>언어선택 (language)</span>
        <ul className='translate_select_list' role='listbox' tabIndex='0' id={listBoxId} onKeyDown={handleKeyDownEvent} aria-labelledby={labelId} aria-activedescendant={`${listBoxId}-1`}>
          <li role='option' className='translate_select_cont' id={`${listBoxId}-1`}>
            <a href='#' className='translate_language notranslate' onClick={handleClick.bind(this, TRANSLATE.CODE_KOR)}>
              {TRANSLATE.TEXT_KOR}
            </a>
          </li>
          <li role='option' className='translate_select_cont' id={`${listBoxId}-2`}>
            <a href='#' className='translate_language notranslate' onClick={handleClick.bind(this, TRANSLATE.CODE_ENG)}>
              {TRANSLATE.TEXT_ENG}
            </a>
          </li>
          <li role='option' className='translate_select_cont' id={`${listBoxId}-3`}>
            <a href='#' className='translate_language notranslate' onClick={handleClick.bind(this, TRANSLATE.CODE_JP)}>
              {TRANSLATE.TEXT_JP}
            </a>
          </li>
          <li role='option' className='translate_select_cont' id={`${listBoxId}-4`}>
            <a href='#' className='translate_language notranslate' onClick={handleClick.bind(this, TRANSLATE.CODE_CN)}>
              {TRANSLATE.TEXT_CN}
            </a>
          </li>
          <li role='option' className='translate_select_cont' id={`${listBoxId}-5`}>
            <a href='#none' className='translate_language notranslate' onClick={handleClick.bind(this, TRANSLATE.CODE_ESP)}>
              {TRANSLATE.TEXT_ESP}
            </a>
          </li>
          <li role='option' className='translate_select_cont' id={`${listBoxId}-6`}>
            <a href='#none' className='translate_language notranslate' onClick={handleClick.bind(this, TRANSLATE.CODE_PT)}>
              {TRANSLATE.TEXT_PT}
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
